import PropTypes from 'prop-types';

export const childrenPropTypes = {
  children: PropTypes.node,
};

export const getRefPropType = elementPropType =>
  PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.any }),
  ]);

export const conditionallyRequired = (propType, condition) => (
  props,
  propName,
  component
) => {
  if (condition(props, propName, component) && props[propName] === undefined) {
    return new Error(`${propName} is a required prop on ${component}.`);
  }

  PropTypes.checkPropTypes(
    { [propName]: propType },
    props,
    propName,
    component
  );
};
